module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("THE CANOPY")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ct"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#bb1",
      "id": "aa1"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:12 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter5#bb2",
      "id": "aa2"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 8:43 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter6#bb3",
      "id": "aa3"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 9:20 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter7#bb4",
      "id": "aa4"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 9:55 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter8#bb5",
      "id": "aa5"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 11:47 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter9#bb6",
      "id": "aa6"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 2:20 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#bb7",
      "id": "aa7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:05 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#bb8",
      "id": "aa8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#bb9",
      "id": "aa9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:27 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#bb10",
      "id": "aa10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#bb11",
      "id": "aa11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:40 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#bb12",
      "id": "aa12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:16 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#bb13",
      "id": "aa13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:08 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#bb14",
      "id": "aa14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 11:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#bb15",
      "id": "aa15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#bb16",
      "id": "aa16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 April 2003: 7:14 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#bb17",
      "id": "aa17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 1:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#bb18",
      "id": "aa18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:52 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#bb19",
      "id": "aa19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#bb20",
      "id": "aa20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 11:52 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#bb21",
      "id": "aa21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:37 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#bb22",
      "id": "aa22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:40 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#bb23",
      "id": "aa23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:55 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#bb24",
      "id": "aa24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 11:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#bb25",
      "id": "aa25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:12 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#bb26",
      "id": "aa26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:01 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#bb27",
      "id": "aa27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 10:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#bb28",
      "id": "aa28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 3:49 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#bb29",
      "id": "aa29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:03 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#bb30",
      "id": "aa30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter34#bb31",
      "id": "aa31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 8:15 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter35#bb32",
      "id": "aa32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 8:35 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter36#bb33",
      "id": "aa33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 11:54 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter37#bb34",
      "id": "aa34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 3:08 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter38#bb35",
      "id": "aa35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:37 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter39#bb36",
      "id": "aa36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:50 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter40#bb37",
      "id": "aa37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:05 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter41#bb38",
      "id": "aa38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter42#bb39",
      "id": "aa39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter43#bb40",
      "id": "aa40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 3:35 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter44#bb41",
      "id": "aa41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:02 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter45#bb42",
      "id": "aa42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:35 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter46#bb43",
      "id": "aa43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter47#bb44",
      "id": "aa44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:59 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter48#bb45",
      "id": "aa45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter49#bb46",
      "id": "aa46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter50#bb47",
      "id": "aa47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:38 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter51#bb48",
      "id": "aa48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 10:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter52#bb49",
      "id": "aa49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 10:28 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter53#bb50",
      "id": "aa50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter54#bb51",
      "id": "aa51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter55#bb52",
      "id": "aa52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 6:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter56#bb53",
      "id": "aa53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 10:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter57#bb54",
      "id": "aa54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 4:39 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter58#bb55",
      "id": "aa55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter59#bb56",
      "id": "aa56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter60#bb57",
      "id": "aa57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 April 2003: 6:40 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter61#bb58",
      "id": "aa58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:02 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter62#bb59",
      "id": "aa59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 7:10 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter63#bb60",
      "id": "aa60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter64#bb61",
      "id": "aa61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:15 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter65#bb62",
      "id": "aa62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 5:45 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter66#bb63",
      "id": "aa63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 9:03 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter67#bb64",
      "id": "aa64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRIL")]), _vm._v(" 2003: 9:30 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter68#bb65",
      "id": "aa65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CTOBER")]), _vm._v(" 2003: 10:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter68a#bb66",
      "id": "aa66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR’S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter69#bb67",
      "id": "aa67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCUSSION")]), _vm._v(" Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UESTIONS FOR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADING")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter70#bb68",
      "id": "aa68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFERENCE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IST")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1f86f4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1a.vue
// module id = 69
// module chunks = 0